import { NgModule, LOCALE_ID, Injectable } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { NgbDatepickerI18n, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { Http, HttpModule } from '@angular/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard, CanDeactivateGuard } from './shared';
import { SharedPipesModule } from './shared/pipes/shared-pipes.module';
import { ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ng2-currency-mask/src/currency-mask.config";

import { CustomReuseStrategy } from './reuse-strategy';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: "right",
    allowNegative: false,
    allowZero: true,
    decimal: ",",
    precision: 2,
    prefix: "€ ",
    suffix: "",
    thousands: ""
};

import {
	AuthenticationService,
	UserService,
	CompanyService,
	ContactService,
	OfferService,
	ClassificationService,
	PricelistService,
	DeliveryMethodService,
	PaymentConditionService,
	RepresentativeService,
	SystemCountryService,
	ProvinceService,
	ProductService,
	OrderService,
	ProfileService,
	SubscriptionService,
	ProfilerService,
	SettingsService,
    DashboardService,
    CountryService,
    RegionService,
    WineryService,
    ColorService,
    FavoriteService,
    GrapeService,
    TastetypeService,
    AppellationService,
    VolumeService,
    StockService,
    ShippingcostService,
    VoucherService
} from '@services'

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: Http) {
    // for development
    // return new TranslateHttpLoader(http, '/start-angular/SB-Admin-BS4-Angular-4/master/dist/assets/i18n/', '.json');
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}
@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,
		HttpClientModule,
        AppRoutingModule,
		NgbModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [Http]
            }
        }),
		SharedPipesModule,
		ConfirmDialogModule,
		NgxDnDModule,
        CurrencyMaskModule
    ],
    providers: [
		AuthGuard,
		CanDeactivateGuard,
		AuthenticationService,
		UserService,
		CompanyService,
		ContactService,
		OfferService,
		ClassificationService,
		PricelistService,
		DeliveryMethodService,
		PaymentConditionService,
		RepresentativeService,
		SystemCountryService,
		ProvinceService,
		ProductService,
		OrderService,
		ProfileService,
		SubscriptionService,
		ProfilerService,
		SettingsService,
        DashboardService,
        CountryService,
        RegionService,
        WineryService,
        ColorService,
        FavoriteService,
        GrapeService,
        TastetypeService,
        AppellationService,
        VolumeService,
        StockService,
        ShippingcostService,
        VoucherService,
		MessageService,
		ConfirmationService,
		// { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
		{ provide: LOCALE_ID, useValue: 'nl' },
		{ provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }

	],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/app.module.ts